// /**
//  *
//  * Dashboard
//  *
//  */

import React, { useEffect, useState } from "react";
import { FormattedMessage } from "lib/intl";
import { Link } from "react-router-dom";

// api
import { dashboardReport } from "lib/api/dashboardRequest";

// ui
import { Grid, Flex } from "@domonda/ui";
import * as Icons from "lib/domonda-icons";
import { CircularLoading } from "modules/Loading/CircularLoading";
import { decorate } from "./decorate";

// chart
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

import { useIntl } from 'react-intl';

const DashboardPage = (props: any) => {
  const { classes } = props;
  const date = new Date();
  const labels: any = [];
  const deletedArr: any = [];
  const validatedErrorArr: any = [];
  const validatedNecessaryArr: any = [];
  const validatedUnnecessaryArr: any = [];
  const autoprocessedArr: any = [];
  const [isLoading, setIsLoading] = useState(true);
  const [isPercentage, setIsPercentage] = useState(false);
  const [datasets, setDatasets] = useState<any>({});
  const [datasetsPercentage, setDatasetsPercentage] = useState<any>({});
  const [nonFilterdatasets, setNonFilterDatasets] = useState<any>([]);
  const [isValidated, setIsValidated] = useState<boolean>(true);
  const [isCorrected, setIsCorrected] = useState<boolean>(true);
  const [isAccepted, setIsAccepted] = useState<boolean>(true);
  const [isAutoprocessed, setIsAutoprocessed] = useState<boolean>(true);
  const [isDropdownActive, setIsDropdownActive] = useState<boolean>(false);
  const [isDropdownSecActive, setIsDropdownSecActive] = useState<boolean>(false);

  const { formatMessage } = useIntl();

  const calculatePercentage = (x: any, y: any) => {
    if (x === 0 && y === 0) return 0;
    return Math.ceil((x / (x + y)) * 100);
  };

  const transformToPercentage = (autoprocessed: any, validated: any) => {
    const processedPerc = autoprocessed.map((item: any, index: any) => {
      return calculatePercentage(item, validated[index]);
    });
    const validatedPerc = processedPerc.map((item: any, index: any) => {
      if (item === 0 && validated[index] === 0) return 0;
      return 100 - item;
    });
    return { autoprocessed: processedPerc, validated: validatedPerc };
  };

  useEffect(() => {
    filterChartValue();
  }, [isAccepted, isCorrected, isValidated, isAutoprocessed]);

  useEffect(() => {
    async function getChartData() {
      const month0 = await dashboardReport(
        new Date(date.getFullYear(), date.getMonth(), 1).toISOString(),
        new Date(date.getFullYear(), date.getMonth() + 1, 1).toISOString()
      );

      const month1 = await dashboardReport(
        new Date(date.getFullYear(), date.getMonth() - 1, 1).toISOString(),
        new Date(date.getFullYear(), date.getMonth(), 1).toISOString()
      );
      const month2 = await dashboardReport(
        new Date(date.getFullYear(), date.getMonth() - 2, 1).toISOString(),
        new Date(date.getFullYear(), date.getMonth() - 1, 1).toISOString()
      );
      const month3 = await dashboardReport(
        new Date(date.getFullYear(), date.getMonth() - 3, 1).toISOString(),
        new Date(date.getFullYear(), date.getMonth() - 2, 1).toISOString()
      );
      const month4 = await dashboardReport(
        new Date(date.getFullYear(), date.getMonth() - 4, 1).toISOString(),
        new Date(date.getFullYear(), date.getMonth() - 3, 1).toISOString()
      );
      const month5 = await dashboardReport(
        new Date(date.getFullYear(), date.getMonth() - 5, 1).toISOString(),
        new Date(date.getFullYear(), date.getMonth() - 4, 1).toISOString()
      );
      const month6 = await dashboardReport(
        new Date(date.getFullYear(), date.getMonth() - 6, 1).toISOString(),
        new Date(date.getFullYear(), date.getMonth() - 5, 1).toISOString()
      );
      const month7 = await dashboardReport(
        new Date(date.getFullYear(), date.getMonth() - 7, 1).toISOString(),
        new Date(date.getFullYear(), date.getMonth() - 6, 1).toISOString()
      );
      const month8 = await dashboardReport(
        new Date(date.getFullYear(), date.getMonth() - 8, 1).toISOString(),
        new Date(date.getFullYear(), date.getMonth() - 7, 1).toISOString()
      );
      const month9 = await dashboardReport(
        new Date(date.getFullYear(), date.getMonth() - 9, 1).toISOString(),
        new Date(date.getFullYear(), date.getMonth() - 8, 1).toISOString()
      );
      const month10 = await dashboardReport(
        new Date(date.getFullYear(), date.getMonth() - 10, 1).toISOString(),
        new Date(date.getFullYear(), date.getMonth() - 9, 1).toISOString()
      );
      const month11 = await dashboardReport(
        new Date(date.getFullYear(), date.getMonth() - 11, 1).toISOString(),
        new Date(date.getFullYear(), date.getMonth() - 10, 1).toISOString()
      );
      labels[11].data = month0;
      labels[10].data = month1;
      labels[9].data = month2;
      labels[8].data = month3;
      labels[7].data = month4;
      labels[6].data = month5;
      labels[5].data = month6;
      labels[4].data = month7;
      labels[3].data = month8;
      labels[2].data = month9;
      labels[1].data = month10;
      labels[0].data = month11;

      labels.forEach((item: any) => {
        // Delete data before March 2022
        if (
          item.name === "Jun 2021" ||
          item.name === "Jul 2021" ||
          item.name === "Aug 2021" ||
          item.name === "Sep 2021" ||
          item.name === "Oct 2021" ||
          item.name === "Nov 2021" ||
          item.name === "Dec 2021" ||
          item.name === "Jan 2022" ||
          item.name === "Feb 2022"
        ) {
          deletedArr.push(0);
          validatedErrorArr.push(0);
          validatedNecessaryArr.push(0);
          validatedUnnecessaryArr.push(0);
          autoprocessedArr.push(0);
          return;
        }

        deletedArr.push(item.data.AutoprocessabilityDataArray[0].DeletedCount);
        validatedErrorArr.push(
          item.data.AutoprocessabilityDataArray[0].ValidatedErrorCount
        );
        validatedNecessaryArr.push(
          item.data.AutoprocessabilityDataArray[0].ValidatedNecessaryCount
        );
        validatedUnnecessaryArr.push(
          item.data.AutoprocessabilityDataArray[0].ValidatedUnnecessaryCount
        );
        autoprocessedArr.push(
          item.data.AutoprocessabilityDataArray[0].AutoprocessedCount
        );
      });

      const validatedArr = validatedNecessaryArr.map(
        (a: any, i: any) =>
          a + validatedUnnecessaryArr[i] + deletedArr[i] + validatedErrorArr[i]
      );
      const correctedArr = validatedNecessaryArr.map(
        (a: any, i: any) => a + deletedArr[i] + validatedErrorArr[i]
      );

      const percentageTempValue = transformToPercentage(
        autoprocessedArr,
        validatedArr
      );

      const tempDatasets = [
        {
          label: formatMessage({ id: 'DOCUMENT_DASHBOARD_AUTOPROCESSED' }),
          data: autoprocessedArr,
          backgroundColor: "#00AAE9",
        },
        {
          label: formatMessage({ id: 'DOCUMENT_DASHBOARD_VALIDATED' }),
          data: validatedArr,
          backgroundColor: "#84A98C",
        },
        {
          label: formatMessage({ id: 'DOCUMENT_DASHBOARD_CORRECTED' }),
          data: correctedArr,
          backgroundColor: "#F6B716",
        },
        {
          label: formatMessage({ id: 'DOCUMENT_DASHBOARD_ACCEPTED' }),
          data: validatedUnnecessaryArr,
          backgroundColor: "#92D050",
        },
      ];

      const tempDatasetsPercentage = [
        {
          label: formatMessage({ id: 'DOCUMENT_DASHBOARD_AUTOPROCESSED' }),
          data: percentageTempValue.autoprocessed,
          backgroundColor: "#00AAE9",
        },
        {
          label: formatMessage({ id: 'DOCUMENT_DASHBOARD_VALIDATED' }),
          data: percentageTempValue.validated,
          backgroundColor: "#F6B716",
        },
      ];

      setDatasetsPercentage(tempDatasetsPercentage);
      setDatasets(tempDatasets);
      setNonFilterDatasets(tempDatasets);
      setIsLoading(false);
    }
    getChartData();
  }, []);

  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
  );

  const options = {
    plugins: {},
    responsive: true,
    scales: {
      x: {
        stacked: true,
      },
      y: {
        stacked: true,
      },
    },
  };

  const optionsPercentage = {
    plugins: {},
    responsive: true,
    scales: {
      x: {
        stacked: true,
      },
      y: {
        stacked: true,
        ticks: {
          stepSize: 20,
          callback: function (value: any) {
            return value + " %";
          },
        },
      },
    },
  };

  const filterChartValue = () => {
    let tempData = nonFilterdatasets.filter((item: any) => {
      return (
        (item.label === "Validated" && isValidated) ||
        (item.label === "Corrected" && isCorrected) ||
        (item.label === "Accepted" && isAccepted) ||
        (item.label === "Autoprocessed" && isAutoprocessed)
      );
    });
    setDatasets(tempData);
  };

  const d = new Date();
  const monthName = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  d.setDate(1);
  for (let i = 0; i <= 11; i++) {
    labels.unshift({ name: `${monthName[d.getMonth()]} ${d.getFullYear()}` });
    d.setMonth(d.getMonth() - 1);
  }

  if (isLoading) return <CircularLoading />;

  const data = {
    labels: labels.map((item: any) => item.name),
    datasets,
  };

  const dataPercentage = {
    labels: labels.map((item: any) => item.name),
    datasets: datasetsPercentage,
  };

  return (
    <Grid
      container
      fill
      template={`
            'navigation content' 1fr
            / 225px 1fr`}
    >
      <Grid className={classes.navigation} area="navigation" overflowing>
        <Flex container direction="column">
          <Flex item>
            <Link className={classes.sidebarItem} to="/">
              <Icons.Documents className="icon" />
              <FormattedMessage id="DOCUMENTS_DOCUMENTS" />
            </Link>
            <Link className={classes.sidebarItem} to="/dashboard">
              <Icons.DashboardIcon className="icon" />
              Dashboard
            </Link>
          </Flex>
        </Flex>
      </Grid>
      <Grid area="content" overflowing>
        <div className={classes.chartWrapper}>
          <h1 className={classes.chartTitle}>
            <FormattedMessage id="DOCUMENT_DASHBOARD_TITLE" />
          </h1>
          <div
            className={classes.dropdownOverlay}
            onClick={() => {
              setIsDropdownActive(false);
              setIsDropdownSecActive(false);
            }}
            style={{ display: (isDropdownActive || isDropdownSecActive) ? "block" : "none", }}
          ></div>
          <div className={classes.buttonsContainer}>
            <div className={classes.dropdownContainer}>
              <div
                className={classes.dropdown}
                onClick={() => {
                  setIsDropdownActive(!isDropdownActive);
                  isDropdownSecActive && setIsDropdownSecActive(false);
                }}
              >
                <p className={classes.dropdownTitle}>
                  <FormattedMessage id="DOCUMENT_DASHBOARD_MEASURED_VALUES" />
                </p>
                <div className={classes.dropdownFlex}>
                  <p className={classes.dropdownSubtitle}>
                    <FormattedMessage id="DOCUMENT_DASHBOARD_ACCEPTED_VALUES" />
                  </p>
                  <Icons.DropdownArrowDown
                    className={classes.dropdownIcon}
                    style={
                      isDropdownActive ? { transform: "rotate(180deg)" } : {}
                    }
                  />
                </div>
              </div>
              {isDropdownActive && (
                <div className={classes.dropdownContent}>
                  <div className={classes.dropdownItem}>
                    <input
                      type="checkbox"
                      id="autoprocessed"
                      name="autoprocessed"
                      checked={isAutoprocessed}
                      onChange={() => {
                        setIsAutoprocessed(!isAutoprocessed);
                      }}
                    />
                    <label
                      className={classes.dropdownLabel}
                      htmlFor="autoprocessed"
                    >
                      <FormattedMessage id="DOCUMENT_DASHBOARD_AUTOPROCESSED" />
                    </label>
                  </div>
                  <div className={classes.dropdownItem}>
                    <input
                      type="checkbox"
                      id="validated"
                      name="validated"
                      checked={isValidated}
                      onChange={() => {
                        setIsValidated(!isValidated);
                        setIsCorrected(false);
                        setIsAccepted(false);
                      }}
                    />
                    <label
                      className={classes.dropdownLabel}
                      htmlFor="validated"
                    >
                      <FormattedMessage id="DOCUMENT_DASHBOARD_VALIDATED" />
                    </label>
                  </div>
                  <div
                    className={`${classes.dropdownItem} ${classes.subitemMargin}`}
                  >
                    <input
                      type="checkbox"
                      id="corrected"
                      name="corrected"
                      checked={isCorrected}
                      disabled={isValidated}
                      onChange={() => {
                        setIsCorrected(!isCorrected);
                      }}
                    />
                    <label
                      className={classes.dropdownLabel}
                      htmlFor="corrected"
                    >
                      <FormattedMessage id="DOCUMENT_DASHBOARD_CORRECTED" />
                    </label>
                  </div>
                  <div
                    className={`${classes.dropdownItem} ${classes.subitemMargin}`}
                  >
                    <input
                      type="checkbox"
                      id="accepted"
                      name="accepted"
                      checked={isAccepted}
                      disabled={isValidated}
                      onChange={() => {
                        setIsAccepted(!isAccepted);
                      }}
                    />
                    <label className={classes.dropdownLabel} htmlFor="accepted">
                      <FormattedMessage id="DOCUMENT_DASHBOARD_ACCEPTED" />
                    </label>
                  </div>
                </div>
              )}
            </div>

            {/*Option 2*/}
            <div className={classes.dropdownContainer}>
              <div
                className={classes.dropdown}
                onClick={() => {
                  setIsDropdownSecActive(!isDropdownSecActive);
                  isDropdownActive && setIsDropdownActive(false);
                }}
              >
                <p className={classes.dropdownTitle}>
                  <FormattedMessage id="DOCUMENT_DASHBOARD_UNIT" />
                </p>
                <div className={classes.dropdownFlex}>
                  <p className={classes.dropdownSubtitle}>
                    {isPercentage
                      ? <FormattedMessage id="DOCUMENT_DASHBOARD_UNIT_PERCENT" />
                      : <FormattedMessage id="DOCUMENT_DASHBOARD_UNIT_ABSOLUTE" />
                    }
                  </p>
                  <Icons.DropdownArrowDown
                    className={classes.dropdownIcon}
                    style={
                      isDropdownSecActive ? { transform: "rotate(180deg)" } : {}
                    }
                  />
                </div>
              </div>
              {isDropdownSecActive && (
                <div className={classes.dropdownContent}>
                  <div className={classes.dropdownItem}>
                    <input
                      type="radio"
                      checked={!isPercentage}
                      id="absolute"
                      name="percent"
                      onChange={() => {
                        setIsPercentage(false);
                      }}
                    />
                    <label className={classes.dropdownLabel} htmlFor="absolute">
                      <FormattedMessage id="DOCUMENT_DASHBOARD_UNIT_ABSOLUTE" />
                    </label>
                  </div>
                  <div className={classes.dropdownItem}>
                    <input
                      type="radio"
                      id="percent"
                      checked={isPercentage}
                      name="percent"
                      onChange={() => {
                        setIsPercentage(true);
                      }}
                    />
                    <label className={classes.dropdownLabel} htmlFor="percent">
                      <FormattedMessage id="DOCUMENT_DASHBOARD_UNIT_PERCENT" />
                    </label>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className={classes.barWrapper}>
            {isPercentage ? (
              <Bar options={optionsPercentage} data={dataPercentage} />
            ) : (
              <Bar options={options} data={data} />
            )}
          </div>
        </div>
      </Grid>
    </Grid>
  );
};

const ComposedDashboardPage = decorate(DashboardPage);
export { ComposedDashboardPage as DashboardPage };

